import { render, staticRenderFns } from "./FinanceTabTurnover.vue?vue&type=template&id=4de5d73b&scoped=true"
import script from "./FinanceTabTurnover.vue?vue&type=script&lang=js"
export * from "./FinanceTabTurnover.vue?vue&type=script&lang=js"
import style0 from "./FinanceTabTurnover.vue?vue&type=style&index=0&id=4de5d73b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de5d73b",
  null
  
)

export default component.exports